<template>
    <div>
        <filter-sidebar-layout
            :filter-key="'filter-sidebar-tyre-auto'"
            :loading="loading"
            :fields="getFields"
            :disabled-values="disabledValues"
            v-on:change="filterValues()"
            v-on:submit="updateProductList"/>
    </div>
</template>

<script>
    import FilterSidebarLayout from "./FilterSidebarLayout";
    import { mapState, mapActions, mapGetters } from 'vuex';

    export default {
    name: "TheFilterSidebarTyreAuto",
    components: {FilterSidebarLayout},
    computed: {
      ...mapState('sidebarAutoTyreModule', {
        paramInfo: 'paramInfo',
        loading: 'loading',
      }),
      ...mapGetters('sidebarAutoTyreModule', {
        isCurrentPossible: 'isCurrentPossible',
        getFields: 'getFields',
        disabledValues: 'getDisabledValues'
      }),
    },
    methods: {
      ...mapActions('sidebarAutoTyreModule', {
        filterValues: 'filterValues',
        updateProductList: 'updateProductList',
      }),
    }
  }
</script>